import { ExtendedWrapUpSettings } from 'utils/domain/extendedWrapUpSettings';
import { ExtendedWrapUpService } from './extendedWrapUpService';

export interface ApiExtendedWrapUp {
    IsAgentInWrapUp(sip: string): Promise<boolean>;
    GetOngoingWrapUpSettings(sip: string): Promise<ExtendedWrapUpSettings>;
}

export const socketWrapUp = new ExtendedWrapUpService();
